module.exports = __webpack_public_path__ + "img/Lao-People's-Democratic-Republic.582ccd1f.png";